import { PRICING_WHY_FEATURES } from '../../constants/homeData';
import whySubscribeBg from '../../assets/images/why-subscribe-bg.png';
import iconOffline from '../../assets/images/feature-icon-offline.png';
import iconLive from '../../assets/images/feature-icon-live.png';
import iconDoubt from '../../assets/images/feature-icon-doubt.png';
import iconProgress from '../../assets/images/feature-icon-progress.png';

const FEATURE_ICONS = {
  live: iconLive,
  syllabus: iconProgress,
  doubt: iconDoubt,
  offline: iconOffline,
  quiz: iconProgress,
  notes: iconOffline,
};

function FeatureCard({ label, iconId }) {
  const icon = FEATURE_ICONS[iconId] || iconLive;

  return (
    <li className="flex items-center gap-4 rounded-2xl bg-white px-5 py-5 shadow-[0_4px_24px_rgba(0,0,0,0.2)]">
      <img src={icon} alt="" className="h-10 w-10 shrink-0 object-contain sm:h-11 sm:w-11" aria-hidden />
      <span className="text-base font-medium leading-snug text-[#000000] sm:text-[20px]">{label}</span>
    </li>
  );
}

export default function WhySubscribeSection() {
  return (
    <section className="pt-6 lg:pt-14">
      <div className="w-full">
        <h2 className="text-center text-2xl font-bold text-[#181059] sm:text-[32px] lg:text-[40px]">
          Why Subscribe to CHSE Express?
        </h2>

        <div className="relative mt-8 sm:mt-14">
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <img
              src={whySubscribeBg}
              alt=""
              aria-hidden
              className="h-full w-full object-cover object-center"
            />
          </div>

          <div className="relative z-10 overflow-visible px-4 py-8 sm:px-6 sm:py-20 lg:px-12 lg:py-24">
            <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-10">
              {PRICING_WHY_FEATURES.map((feature) => (
                <FeatureCard key={feature.id} label={feature.label} iconId={feature.id} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
